import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqs as mockFaqs } from '../../data/mock';
import { cmsService } from '../../services/cmsService';

const FAQ = () => {
  const [faqs, setFaqs] = useState(mockFaqs);

  useEffect(() => {
    cmsService.getFAQ().then(data => {
      if (data && data.length > 0) setFaqs(data);
    }).catch(() => {});
  }, []);

  return (
    <section id="faq" className="py-24 bg-white relative overflow-hidden" data-testid="faq-section">
      {/* Background decoration */}
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-[#0092ca]/5 to-transparent" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#0092ca]/10 text-[#0092ca] text-sm font-semibold rounded-full mb-4">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Preguntas{' '}
            <span className="text-[#0092ca]">Frecuentes</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Resolvemos tus dudas sobre el factoring y cómo FACTORYZA 
            puede ayudar a tu empresa.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              data-testid={`faq-item-${index}`}
              className="bg-white border border-gray-200 rounded-2xl px-6 shadow-sm hover:shadow-md transition-shadow duration-300 data-[state=open]:border-[#0092ca]/30 data-[state=open]:shadow-lg"
            >
              <AccordionTrigger className="py-6 text-left hover:no-underline group">
                <div className="flex items-center gap-4">
                  <span className="flex-shrink-0 w-8 h-8 bg-[#0092ca]/10 text-[#0092ca] rounded-lg flex items-center justify-center text-sm font-bold group-data-[state=open]:bg-[#0092ca] group-data-[state=open]:text-white transition-colors">
                    {index + 1}
                  </span>
                  <span className="text-lg font-semibold text-gray-900 group-hover:text-[#0092ca] transition-colors">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-12 text-gray-600 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional help */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 mb-4">
            ¿Tienes más preguntas? Contáctanos directamente:
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/50765865503"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-btn"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#25D366] text-white font-semibold rounded-full hover:bg-[#1da851] transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp
            </a>
            <a
              href="mailto:info@factoryza.com?subject=Consulta%20sobre%20Factoring"
              data-testid="faq-email-btn"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#0092ca] text-white font-semibold rounded-full hover:bg-[#007bb5] transition-colors"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              info@factoryza.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
